import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FilterGenerique } from '@models/api/requests';
import { PagedResultDTO } from '@models/shared';
import { ServiceFonctionnelPoste as ServiceFonctionnel } from '@models/domains/posts';

@Injectable({
  providedIn: 'root'
})
export class ServicesFonctionnelsService {
  private readonly apiUrl = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private readonly http: HttpClient) {}

  getAllServices(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/services-fonctionnels`);
  }

  getServicesByDirection(directionId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/services-fonctionnels/by-direction/${directionId}`);
  }

  getAllServicesList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/services-fonctionnels/all`);
  }

  getListOfServices(offset: number, limit: number, filtre: FilterGenerique | null = null): Observable<PagedResultDTO<ServiceFonctionnel>> {
    let url = this.apiUrl + '/services-fonctionnels/all';
    let params = new HttpParams().set('page', offset).set('size', limit);

    if (filtre?.filterGenerique) {
      params = params.set('filterGenerique', filtre.filterGenerique);
    }

    return this.http.get<PagedResultDTO<ServiceFonctionnel>>(`${this.apiUrl}/services-fonctionnels`, { params });
  }
  // Modification service
  modifierService(data: any, id: number) {
    return this.http.put<any>(this.apiUrl + '/services-fonctionnels/' + id, data);
  }
}
